import PropTypes from 'prop-types';
// @mui
import { Box, Card, LinearProgress } from '@mui/material';
// components
import Chart, { useChart } from '../../../components/chart';
import { fCurrency } from '../../../utils/formatNumber';
// ----------------------------------------------------------------------

HomeLastSales.propTypes = {
  chart: PropTypes.array,
  fetching: PropTypes.bool,
};

export default function HomeLastSales({ fetching, chart = [], ...other }) {
  const categories = chart?.map((c) => c.date?.substring(0, 5)) || [];
  const data = chart?.map((c) => c.amount) || [];
  const series = { data: [{ name: '', data }] };

  const formatTooltip = (time, value) => {
    if (time?.includes(':')) return `${time} <br> ${fCurrency(value)}`;
    return time?.includes('-')
      ? `Dia ${time.replace('-', '/')} <br> ${fCurrency(value)}`
      : `Mês de ${time} <br> ${fCurrency(value)}`;
  };

  const chartOptions = useChart({
    legend: {
      position: 'top',
      horizontalAlign: 'right',
    },
    xaxis: {
      categories,
    },
    tooltip: {
      y: {
        formatter: (value, { dataPointIndex }) => {
          const time = categories[dataPointIndex];
          const formattedValue = formatTooltip(time, value);
          return formattedValue;
        },
      },
    },
  });

  return (
    <Card {...other}>
      {fetching && <LinearProgress sx={{ position: 'absolute', top: 0, left: 0, width: '100%' }} />}
      <Box key={series.label} sx={{ mt: 3, mx: 3 }} dir="ltr">
        <Chart type="area" series={series.data} options={chartOptions} height={450} />
      </Box>
    </Card>
  );
}
